import { render, staticRenderFns } from "./CorporateClients.vue?vue&type=template&id=7c124a49&"
import script from "./CorporateClients.vue?vue&type=script&lang=js&"
export * from "./CorporateClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports